<template>
    <div>
        <v-layout row wrap>
            <!-- ...otros filtros... -->
        </v-layout>
        <v-layout>
            <v-flex xs12 v-if="empresaCargada">
                <isotope ref="cpt" :list="list" id="root_isotope" :options='isotope_options' v-images-loaded:on.progress="layout" >
                    <div class="element-item" v-for="(item, index) in list" :key="item.id" v-if="showTipoPropiedad(item.AppTipoPropiedad.id) && showEmpresa(item.Sucursal.Empresa.id)">
                        <router-link :to="{ name: 'AppInmuebleView', params: { id: item.id }}">
                            <v-card hover class="elevation-13 card-item">
                                <v-card-title>
                                    <h3 class="headline text--darken-1">{{item.description}}</h3>
                                </v-card-title>
                                <div v-if="item.AppInmuebleEstado.id != 1" class="ribbon">
                                    <span>{{item.AppInmuebleEstado.description}}</span>
                                </div>
                                <!-- Imagen principal, usando <img> para que no se corte -->
                                <div v-if="item.ManyAppInmuebleImage[0]" style="text-align:center;">
                                    <img
                                        :src="item.ManyAppInmuebleImage[0].description"
                                        style="width:100%; max-height:150px; object-fit:contain; background:#D9D9D9;"
                                        alt="Imagen inmueble"
                                    />
                                    <div class="text-xs-right" style="width:100%;">
                                        <v-chip label class="lime accent-2 ">{{ item.AppTipoOperacion.description }}</v-chip>
                                    </div>
                                </div>
                                <template v-else>
                                    <p class="text-xs-right">
                                        <v-chip label class="lime accent-2 ">{{ item.AppTipoOperacion.description }}</v-chip>
                                    </p>
                                </template>
                                <v-divider></v-divider>
                                <v-chip label>{{ item.AppTipoPropiedad.singular }}</v-chip>
                                <v-chip label v-if="item.precio > 0 && item.AppTipoMoneda && item.AppTipoMoneda.codigo">
                                    <strong>{{ item.AppTipoMoneda.codigo }} {{ item.precio.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") }}</strong>
                                </v-chip>
                                <v-divider></v-divider>
                                <v-chip v-if="item.cantidad_dormitorios > 0" label outline class="grey lighten-4">
                                    {{ item.cantidad_dormitorios }}
                                    <template v-if="item.cantidad_dormitorios == 1">Dormitorio</template>
                                    <template v-if="item.cantidad_dormitorios > 1">Dormitorios</template>
                                </v-chip>
                                <v-chip v-if="item.cantidad_banios > 0" label outline class="grey lighten-4">
                                    {{ item.cantidad_banios}}
                                    <template v-if="item.cantidad_banios == 1">Baño</template>
                                    <template v-if="item.cantidad_banios > 1">Baños</template>
                                </v-chip>
                                <v-chip v-if="item.cantidad_cocheras > 0" label outline class="grey lighten-4">
                                    {{ item.cantidad_cocheras}}
                                    <template v-if="item.cantidad_cocheras == 1">Cochera</template>
                                    <template v-if="item.cantidad_cocheras > 1">Cocheras</template>
                                </v-chip>
                            </v-card>
                        </router-link>
                    </div>
                </isotope>
                <infinite-loading :on-infinite="onInfinite" ref="InfiniteLoading" :distance="500" spinner="spiral">
                    <span slot="no-more"></span>
                </infinite-loading>
            </v-flex>
        </v-layout>
    </div>
</template>

<style>

.element-item a{
	text-decoration: none;
}
/* Custom, iPhone Retina */
@media only screen and (min-width : 320px) {
	.element-item{
		width:100%;
		/*border:1px solid #ff0000;*/
	}
}
/* Extra Small Devices, Phones */
@media only screen and (min-width : 480px) {
	.element-item{
		width:100%;
		/*border:1px solid #ff0000;*/
	}
}
/* Small Devices, Tablets */
@media only screen and (min-width : 768px) {
	.element-item{
		width:50%;
		/*border:1px solid #ff0000;*/
	}
}
/* Medium Devices, Desktops */
@media only screen and (min-width : 992px) {
	.element-item{
		width:33%;

		/*border:1px solid #ff0000;*/
	}
}
/* Large Devices, Wide Screens */
@media only screen and (min-width : 1200px) {
	.element-item{
		width:25%;
	}

}
.element-item{
	padding:0 10px 20px 10px;
	float:left;
	/*border:1px solid #ff0000;*/
}
.element-item v-card{
	padding:10px;
}
.card-item{
	padding:10px;
}
</style>
<script>
  import InfiniteLoading from 'vue-infinite-loading'
  import Isotope from 'vueisotope'
  import ImagesLoaded from 'vue-images-loaded'
  import AppTipoPropiedad from '@/components/AppTipoPropiedad'
  import axios from 'axios';
  export default {
    data () {
      return {
		// -
		list: [],
	    page: 0,
	    per_page: null,
	    total: null,
	    last_page: 99,
		app_tipo_propiedad_id: '',
		app_tipo_operacion_id: '',
	    // -isotope
		selected: null,
		filterOption: "todas",
	    isotope_options: {
		  itemSelector: '.element-item',
    	  layoutMode: 'masonry',
		  transitionDuration: 0,
		  getFilterData: {
			todas: function(el) {
			  return true;
			  return el.destacado == 1;
            },
            venta: function(el, key) {
			  return el.AppTipoOperacion.id == 1;
            },
            alquiler: function(el) {
              return el.AppTipoOperacion.id == 2;
		    }
          },
		  masonry: {
		    gutterWidth: 10
		  }
	    }
      }
    },
	//
	head: {
	   title: function () {
	      if(this.empresa.id)
	      {
	      	return {
	        	inner: this.empresa.description,
	       	 	complement: 'Inmobiliaria'
	      	}
	      }else{
		      return {
		        inner: this.empresa.description,
		        complement: '9dejulio.com'
		      }
	      }
	      
	    }
	},
	watch: {
        app_tipo_propiedad_id: function(key) {
            this.page = 0
			this.last_page = 99
			this.$refs.InfiniteLoading.$emit('$InfiniteLoading:reset');
        },
        empresa: function(key){
        	this.$emit('updateHead')
        }
    },
	components: {
      InfiniteLoading,
	  Isotope,
	  AppTipoPropiedad
    },
	directives: {
		ImagesLoaded
	},
	computed: {
	    empresa () {
	      return this.$store.getters.brand
	    },
		empresaCargada () {
	      return this.$store.getters.brandReady
	    }
	  },
	mounted: function () {
	  this.$nextTick(function () {
	    //this.filter(this.filterOption);
	  })
    },
	methods: {
		fetchData () {

	        this.page++
			// console.log('fetchdata: ' + this.page );
	        axios.get(this.$apiUrl + 'app_inmueble', {
	          params: {
	            page: this.page,
	            tipo_propiedad: this.app_tipo_propiedad_id,
	            empresa_id: this.empresa.id
	          }
	        }).then(response => {
			  this.last_page = response.data.last_page;
	          if (response.data.items.length) {
	            // ??????????????
	            for (var i = 0; i < response.data.items.length; i++) {
	              var f = false
	              for (var ii = 0; ii < this.list.length; ii++) {
	                if (this.list[ii].id === response.data.items[i].id) {
	                  f = true
	                }
	              }
	              if (!f) {
	                this.list.push(response.data.items[i])
	              }
	            }
	            // ???????1???????
	            this.$refs.InfiniteLoading.$emit('$InfiniteLoading:loaded')
	            if (response.data.last_page === this.page) {
	              this.$refs.InfiniteLoading.$emit('$InfiniteLoading:complete')
	            }
	          } else {
	            this.$refs.InfiniteLoading.$emit('$InfiniteLoading:complete')
	          }
	        })
	},

	showTipoPropiedad: function (id) {
		if(this.app_tipo_propiedad_id){
			return this.app_tipo_propiedad_id == id;
		}
		return true;
	},
	showEmpresa: function (id) {
		if(!this.empresa.id){
			return true;
		}
		return this.empresa.id == id;
	},

   layout: function () {
	 this.$refs.cpt.layout('masonry')
   },
   onInfinite: function () {
	 this.fetchData()
 },
 filter: function(key) {
	 /*
	 //console.log(key);
            if(key == 'venta'){
              this.app_tipo_operacion_id = 1
            }else if(key == 'alquiler'){
              this.app_tipo_operacion_id = 2
            }else{
              //todos?
              this.app_tipo_operacion_id = null
            }
            this.page = 0;
            this.$refs.InfiniteLoading.$emit('$InfiniteLoading:reset');
	*/
            this.$refs.cpt.filter(key);
			this.filterOption = key;
        },
 }

  }
</script>



// WEBPACK FOOTER //
// Main.vue?e88f65a6